import axios from "axios"
import { IsLoadingAction } from "./variables"

// DEFAULT VALUE

const defaultValue = {
    data: false,
    currentWeather: '',
    extendedForecast: ''

}

// ACTION TYPES

const GETCURRENTWEATHER = 'GETCURRENTWEATHER'


// REDUCER

export default function WeatherReducer(state = defaultValue, { type, payload }) {
    switch(type){
        case GETCURRENTWEATHER: return {...state, data: payload.data, currentWeather: payload.currentWeather, extendedForecast: payload.extendedForecast }
        default: return state
    }

}


// ACTIONS

export const GetWeatherAction = (latitude, longitude) => async (dispatch) => {

    // const dispatch = useDispatch
    
    let isLoading = true

    dispatch(IsLoadingAction({isLoading}))


    const response = {
                        method: 'GET',
                        url: `https://first-weather-back.herokuapp.com/weather-latlon`,
                        params: {latitude: latitude, longitude: longitude}
    
                    } 
    
                    await axios.request(response).then((response) => {
                    


                            dispatch({
                                type: GETCURRENTWEATHER,
                                payload: {data: true, currentWeather: response.data.current, extendedForecast: response.data.daily}
                            })

                            isLoading = false

                            dispatch(IsLoadingAction({isLoading}))
                        

    
                    }).catch((error) => {
                        return console.error(error)
                        
                    })

}

